<template>
  <div class="pc-documents-archive">
    <div class="pc-documents-archive__header">
      <div class="pc-block__title">
        {{ $t('pc.documents.request-archive') }}
      </div>
      <pc-select
        v-model="filter"
        icon="pc-filter"
        class="pc-documents-archive__filter"
        :placeholder="$t('pc.documents.type-filter')"
        :options="docTypes"
        :get-option-label="opt => opt.title[$i18n.locale]"
      ></pc-select>
    </div>
    <div class="pc-table infinite-scroll">
      <div class="pc-table__header">
        <div
          v-for="column in columns"
          :key="column.title"
          class="pc-table__cell"
          :class="{'has-sort': column.hasSort}"
          @click="setSort(column.id)"
        >
          {{ $t(column.title) }}<icu-icon v-if="column.hasSort" class="pc-icon pc-sort" />
        </div>
      </div>
      <template v-if="requests.length">
        <div v-for="row in requests" :key="row.id" class="pc-table__row">
          <div class="pc-table__cell">
            {{ getDocumentType(row.doctype) }}
          </div>
          <div class="pc-table__cell">
            <div></div>
          </div>
          <div class="pc-table__cell">
            {{ dateFormat(row.created) }}
          </div>
          <div class="pc-table__cell">
            <div class="actions">
              <div class="pc-table__status" :class="{'rejected': row.status === 'REJECTED'}">
                <div v-if="row.status === 'IN_PROCESS'" class="pc-table__loader"></div>
                {{ $t(`pc.documents.${row.status}`) }}
              </div>
            </div>
            <div class="media-mobile">
              <div>{{ dateFormat(row.created) }}</div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import PcBlock from '@/components/views/PrivateCabinet/PcBlock'
import IcuIcon from '@/components/common/IcuIcon'
import IcuSelect from '@/components/inputs/IcuSelect'
import PcSelect from '@/components/inputs/PcSelect'
import {mapGetters} from 'vuex'
import {api} from '@/api/api'
export default {
  name: 'PcDocumentsArchive',
  components: {PcSelect, IcuSelect, IcuIcon, PcBlock },
  props: {
    update: {
      type: Boolean,
      default: false
    }
  },
  manosry: null,

  data() {
    return {
      requests: [],
      userDocTypes: [],
      columns: [

        {
          id: 'doctype',
          title: 'pc.documents.doc-type',
          hasSort: true
        },
        {
          title: ''
        },
        {
          id: 'created',
          title: 'pc.documents.request-date',
          hasSort: true
        },
        {
          id: 'status',
          title: 'pc.documents.status',
        }
      ],
      limit: 20,
      offset: 0,
      hasNextPage: false,
      sort: null,
      filter: null,
    }
  },
  computed: {
    ...mapGetters(['documentTypes']),
    docTypes() {
      const docTypes =this.documentTypes.filter(el => this.userDocTypes.includes(el.id))
      docTypes.unshift({title: {uk: 'Всі', en: 'All'}})
      return docTypes
    }
  },
  watch: {
    filter(){
      this.getRequests()
    },
    update(newVal){
      if( newVal){
        this.getRequests()
      }
    }
  },
  mounted() {
    this.$options.masonry = document.querySelector('.pc-content')
    this.$options.masonry.addEventListener('scroll', this.addScrollEvent)

  },
  beforeDestroy() {
    this.$options.masonry.removeEventListener('scroll', this.addScrollEvent)
  },
  methods: {
    async getRequests(getNext = false) {
      if(getNext) {
        this.offset++
      } else {
        this.offset = 0
      }
      const params = {
        limit: this.limit,
        offset: this.offset * this.limit,
        doctype: this.filter,
        ordering: this.sort,
      }
      try {
        const {data} = await api.cabinet.getRequests(params)
        if(!getNext) {
          this.requests = data.results
        } else {
          this.requests.push(...data.results)
        }
        this.hasNextPage = data.next
        this.userDocTypes = data.doctypes
      }catch(err){
        console.log(err)
      }
    },

    addScrollEvent() {
      if (this.$options.masonry.scrollTop + this.$options.masonry.clientHeight >= this.$options.masonry.scrollHeight -1) {

        if (this.hasNextPage) {
          this.getRequests(true)
        }
      }
    },
    setSort(id) {
      if(id) {
        if (this.sort === id) {
          this.sort = '-' + id
        } else {
          this.sort = id
        }
        this.getRequests()
      }
    },

    getDocumentType(id) {
      const index = this.documentTypes.findIndex(el => el.id == id)
      return this.documentTypes[index]?.title[this.$i18n.locale]
    },

    dateFormat(value) {
      const date = new Date(value)
      return date.toLocaleString('ua-UA')
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/theme.scss";

.pc-documents-archive {

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 48px;
    @media (max-width: $tablet){
      flex-direction: column;
      align-items: stretch;
    }

  }

  .pc-block__title  {
    margin-bottom: 0;
  }

  &__filter {
    width: 336px;
    @media (max-width: $tablet){
      width: 100%;
      margin-top: 20px;
    }
  }
  .pc-table__status {
    display: flex;
    align-items: center;
  }

  .media-tablet *{
    color: $passive-text;
    margin-top: 3px;
  }
  .media-mobile *{
    color: $passive-text;
    margin-top: 3px;
  }

  .pc-table__cell {
    flex-grow: 1;
    &:first-child {
      flex-basis: 30%;
      width: 30%;
    }
    &:nth-child(2) {
      flex-basis: 0%;
      width: 0%;
    }
    &:nth-child(3) {
      flex-basis: 15%;
      width: 15%;
    }
    &:last-child {
      flex-basis: 15%;
      width: 15%;
    }
    @media (max-width: $desktop){
      &:first-child {
        flex-direction: column;
        align-items: flex-start;
      }
      &:nth-child(2) {
        display: none;
      }
    }
    @media (max-width: $tablet){

      &:nth-child(3) {
        display: none;
      }
      &:nth-child(4) {
        flex-direction: column;
        align-items: flex-start;
      }
    }
  }

  @media (max-width: $tablet){
    padding-top: 30px;
  }
}
</style>
